<template>
  <div v-show="$store.state.loading.loadingIsVisible" :style="getStyle" class="sr-loading">
    <div class="sr-loading-icon"></div>
    <span v-html="getMessage"></span>
  </div>
</template>
<style>
.sr-loading-icon {
  float: left;
  margin-right: 10px;
  margin-top: 1px;
  border: 3px solid #f3f3f3;
  border-radius: 50%;
  border-top: 3px solid #3498db;
  width: 20px;
  height: 20px;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
}

/* Safari */
@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
<script>
export default {
  name: "Loading",
  props: {
    position: { type: String, required: false, default: "bottom" },
  },
  computed: {
    getMessage() {
      let message = this.$store.state.loading.loadingMessage
      if (message === "") {
        message = this.$t("messages.loadingDefault")
      }
      return message
    },
    getStyle() {
      let style =
        "z-index:100; padding:8px 20px 8px 20px; background-color: orange;border: 2px solid blue; box-shadow: 1px 5px 50px silver; left: 50%; transform: translateX(-50%);"
      if (this.position === "top") {
        style = style + "position: fixed; top:0px; border-top: 0; border-radius: 0 0 10px 10px; "
      }
      if (this.position === "bottom") {
        style = style + "position: fixed; bottom:0px; border-bottom: 0; border-radius: 10px 10px 0 0;"
      }
      return style
    },
  },
}
</script>
